import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  path {\n    &[fill] {\n      fill: ", ";\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-left: auto;\n  opacity: 0.5;\n  cursor: pointer;\n  margin-top: 3px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 26px;\n  margin-left: 10px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  path {\n    fill: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  max-height: 83px;\n  padding: 30px;\n  border-radius: ", "\n    ", " 0px 0px;\n  display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { AcornsIcon } from '@acorns/icons';
import { useRemoteStrings } from '../../utils/providers/remoteStrings';
var HeaderBackground = styled.div(_templateObject(), function (props) {
  return props.theme.colors.charcoal;
}, function (props) {
  return props.theme.borderRadius.large;
}, function (props) {
  return props.theme.borderRadius.large;
});
var ScienceIcon = styled(AcornsIcon)(_templateObject2(), function (props) {
  return props.theme.colors.dusk;
});
var Header = styled.div(_templateObject3(), function (props) {
  return props.theme.colors.white;
});
var CloseContainer = styled.div(_templateObject4());
var CloseButton = styled(AcornsIcon)(_templateObject5(), function (props) {
  return props.theme.colors.white;
});
export var MessagesHeader = function MessagesHeader(_ref) {
  var setShowAIAssistant = _ref.setShowAIAssistant;

  var _useRemoteStrings = useRemoteStrings(),
      getRemoteString = _useRemoteStrings.getRemoteString;

  var hideAIAssistant = function hideAIAssistant() {
    setShowAIAssistant(false);
  };

  return /*#__PURE__*/React.createElement(HeaderBackground, null, /*#__PURE__*/React.createElement(ScienceIcon, {
    icon: AcornsIcon.Icon.UtilityScienceFv,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement(Header, null, getRemoteString({
    key: 'ai_assistant.header.title'
  })), /*#__PURE__*/React.createElement(CloseContainer, {
    onClick: hideAIAssistant
  }, /*#__PURE__*/React.createElement(CloseButton, {
    height: "16px",
    icon: AcornsIcon.Icon.CloseXIcon,
    width: "16px"
  })));
};